import { Injectable } from '@angular/core';
import * as Noty from 'noty';
import { isNumber } from 'lodash-es';
import { EMPTY, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotyService {
  /**
   * Utilized by the various other functions which simplify the Noty API.
   *
   * @param type - See Noty documentation.
   * @param text - The message to display in the notification.
   * @param container - If a selector is specified (for example, '#noty_container'), it will override the layout.
   * @param timeout - defaults to 10 seconds.
   */
  _options(
    type: Noty.Type,
    text: string,
    container?: string,
    timeout?: number,
  ): Noty.Options {
    return {
      closeWith: ['button'],
      container,
      layout: 'topCenter',
      text,
      theme: 'bootstrap-v4',
      timeout: isNumber(timeout) ? timeout : 10000,
      type,
    };
  }

  _notification(
    type: Noty.Type,
    text: string,
    container?: string,
    timeout?: number,
  ) {
    const notification = new Noty(
      this._options(type, text, container, timeout),
    );
    notification.show();

    return notification;
  }

  info(text: string, container?: string, timeout?: number) {
    this._notification('info', text, container, timeout);
  }

  success(text: string, container?: string, timeout?: number) {
    this._notification('success', text, container, timeout);
  }

  error(text: string, container?: string, timeout?: number) {
    this._notification('error', text, container, timeout);
  }

  observableError = (error: Error) => {
    this._notification('error', error.message);
    console.error(error);
    return EMPTY;
  };

  observableErrorWithBackup = (error: Error, backupError = 'API Error') => {
    this._notification('error', error.message || backupError);
    console.error(error);
    return throwError(error);
  };
}
